import { render, staticRenderFns } from "./CvChunk.vue?vue&type=template&id=b2a07b3e&scoped=true&"
import script from "./CvChunk.vue?vue&type=script&lang=js&"
export * from "./CvChunk.vue?vue&type=script&lang=js&"
import style0 from "./CvChunk.vue?vue&type=style&index=0&id=b2a07b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a07b3e",
  null
  
)

export default component.exports